import React from 'react';
import { Reveal } from './Reveal';
import { systemSteps } from '../data/content';
export function System() {
  return <section id="sistema" className="border-b border-white/10 bg-ink-900" aria-labelledby="system-title" data-id="element-111" data-mp="1qwy80efly7o">
      <div className="mx-auto max-w-6xl px-6 py-24 lg:py-28" data-id="element-112" data-mp="6r1dxo7imowu">
        <Reveal className="grid gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-113" data-mp="arl8ql4m9gft">
          <div className="lg:col-span-6" data-id="element-114" data-mp="fpwjcy2qjuz3">
            <p className="text-sm text-zinc-500" data-id="element-115" data-mp="fotv6xwss6mv">La solución</p>
            <h2 id="system-title" className="mt-5 text-3xl font-semibold leading-[1.1] tracking-[-0.02em] text-white sm:text-4xl" data-id="element-116" data-mp="ko6fpc0751ma">
              El Sistema{' '}
              <span className="font-serif italic font-normal text-accent" data-id="element-117" data-mp="uf116e5mbx6o">x7</span>
            </h2>
          </div>
          <p className="text-base leading-relaxed text-zinc-400 lg:col-span-6 lg:pt-12" data-id="element-118" data-mp="yh5ufbs5mrss">
            Tres piezas que casi nadie opera bajo el mismo techo: Paid Media,
            creativos UGC y retención por email. Separadas son tres proveedores
            culpándose entre ellos. Juntas son una máquina donde el creativo baja
            el CPA, el email sube el LTV y ese LTV te permite volver a subir la
            inversión sin romper el MER.
          </p>
        </Reveal>

        <ol className="mt-16 grid gap-px border border-white/10 bg-white/10 lg:grid-cols-3" data-id="element-119" data-mp="lyr9jw9rl63w">
          {systemSteps.map((step, i) => <li key={step.phase} className="flex bg-ink-900" data-id="element-120" data-mp="1jlgiyr6sqkzs" data-mpi={i}>
              <Reveal delay={i * 0.05} className="flex w-full" data-id="element-121" data-mp="1emdep8yn4isv">
                <div className="flex h-full w-full flex-col p-8" data-id="element-122" data-mp="1ep9aorqxgxeo">
                  <p className="font-mono text-xs uppercase tracking-[0.16em] text-accent" data-id="element-123" data-mp="19uvl55yy5khx">
                    {step.phase}
                  </p>
                  <h3 className="mt-6 min-h-[3.5rem] text-xl font-semibold leading-snug tracking-[-0.01em] text-white" data-id="element-124" data-mp="22chgdas9q8h8">
                    {step.title}
                  </h3>
                  <p className="mt-4 text-sm leading-relaxed text-zinc-400" data-id="element-125" data-mp="1xjocsq8jd66q">
                    {step.body}
                  </p>
                  <ul className="mt-auto space-y-2 border-t border-white/10 pt-6" data-id="element-126" data-mp="3vuyjn83yvwr2">
                    {step.levers.map(lever => <li key={lever} className="font-mono text-xs text-zinc-500" data-id="element-127" data-mp="3i30grf0umx3c">
                        {lever}
                      </li>)}
                  </ul>
                </div>
              </Reveal>
            </li>)}
        </ol>

        <Reveal delay={0.12} data-id="element-128" data-mp="3d58g9wm522nj">
          <p className="mt-12 max-w-3xl text-lg leading-relaxed text-zinc-300" data-id="element-129" data-mp="3d5i5hhzd05s6">
            El bucle es el activo: cada punto de LTV que ganamos abajo se
            convierte en margen de puja arriba. Eso es lo que permite escalar de
            forma sostenida en lugar de a base de meses buenos.
          </p>
        </Reveal>
      </div>
    </section>;
}